import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import Button from '../../../shared/atoms/button';
import Connect from '../../../shared/redux/Connect.hoc';
import './styles.scss';

const Welcome = () => {





    return (
        <>
            <div className="Div-welcome">
                <div className='Div-welcome-Div'>
                    <img alt='imagen' src="https://images.vexels.com/media/users/3/236231/isolated/preview/5b1c3bffa604aab44d0030cac9f8fdfe-bienvenido-letras-en-espanol.png" />
                    <h2>Te damos la bienvenida</h2>
                    <p>Reprehenderit tempor exercitation nulla eu velit sit tempor. Laboris eiusmod ullamco eu commodo veniam velit voluptate. Occaecat velit cillum aute id aliqua anim pariatur veniam dolore esse laboris ad tempor excepteur. Labore magna est minim culpa qui consequat voluptate cupidatat consectetur nostrud aliqua ut.</p>
                    <Link to='/perfil'>
                    <Button name="Continuar"/>
                    </Link>

                </div>




            </div>

        </>

    )



}


export default withRouter(Connect(Welcome));